import React from 'react';

import type { Section } from '../../../../../models';
import { SEPARATE_HEATING_CHARGE, UTILITY_CALCULATION_LISTBOX_OPTIONS } from '../../../../../constants';
import UtilitiesCalculation from '../../Utilities/UtilitiesCalculation/UtilitiesCalculation';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function SeparateHeatingChargeCalculation({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesCalculation
      section={section}
      setSectionValues={setSectionValues}
      listBoxField={SEPARATE_HEATING_CHARGE.FIELD_NAME.CALCULATION}
      otherMethodDescriptionField={SEPARATE_HEATING_CHARGE.FIELD_NAME.OTHER_METHOD_DESCRIPTION}
      otherMethodField={SEPARATE_HEATING_CHARGE.FIELD_NAME.OTHER_METHOD}
      options={UTILITY_CALCULATION_LISTBOX_OPTIONS}
      utilityName="Heating"
    />
  );
}

SeparateHeatingChargeCalculation.description =
  'Additional options for how they calculated and whether or not there an additional fee';

export default SeparateHeatingChargeCalculation;
